import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 162px)',
      overflowY: 'auto',

      '& ::-webkit-scrollbar': {
        overflow: 'auto',
        width: '8px',
      },

      '& ::-webkit-scrollbar-thumb': {
        background: '#383838',
        borderRadius: '10px',
      },
    },
    card: {
      padding: '16px',
      borderRadius: 0,
    },
    scrollHide: {
      '& ::-webkit-scrollbar': {
        display: 'none',
      },
      overflow: 'hidden',
    },
    assetProperties: {
      padding: '0px 16px 16px 23px',
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '0px',
      flexBasis: '0%',
    },
    blockShape: {
      minWidth: 32,
      height: 32,
      backgroundColor: '#6d6d6d',
      color: MaterialPalette.common.white,
      fontSize: 20.8,
      position: 'relative',
    },
    textStyles: {
      textAlign: 'center',
      margin: '0 auto 0',
      color: 'black',
    },
    gridLinesLayout: {
      position: 'absolute',
      left: 130,
      top: 60,
      zIndex: 1,
    },
    areaPropertiesMainGrid: {
      padding: '0px 16px 0px 8px',
      backgroundClip: 'content-box',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      overflowY: 'auto',
      height: '100%',
    },
    areaPropertiesChildGrid: {
      maxWidth: '100%',
      flexBasis: 'auto',
      flexFlow: 'column',
    },
    westEastBlock: {
      display: 'inline-block',
      marginRight: '8',
    },
    northSouthBlock: {
      display: 'flex',
      height: '44',
    },
    northSouthblockHeight: {
      lineHeight: '0',
      paddingRight: '16',
    },
    gridFlex: {
      display: 'flex',
      flexDirection: 'row',
    },
    textlabel: {
      fontStyle: 'normal',
    },
    dialogActionGrid: {
      padding: '8px 16px 8px 8px',
      width: '91px',
      height: '44px',
    },
    dialogBtn: {
      width: '91px',
      height: '44px',
    },
    treeViewGrid: {
      display: 'block',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    areaPropertiesText: {
      padding: '16px 0px 19px 23.5px',
    },
    areaPropertiesSubChildGrid: {
      flexDirection: 'column',
      maxWidth: '100%',
    },
    parentAreaGrid: {
      paddingTop: 0,
    },
    riskAssementText: {
      padding: '20px 0px 19px 23.5px',
    },
    offlineText: {
      margin: '16px 0px 16px 0px',
      display: 'flex',
      flexDirection: 'row',
    },
  }),
);

export default useStyles;
